<template>
  <CollapsableSection
    :collapse="false"
    title="System Insights"
  >
    <template v-slot:icon>
      <PremiumFeatureFlag
        feature="systemInsights"
      />
    </template>

    <div :class="$style.content">
      <div :class="[$style.row, $style.firstRow]">
        <InsightsSummary
          :item="item"
          :storageInfo="storageInfo.data"
          :systemInfo="systemInfo.data ? systemInfo.data[0] : {}"
        />
      </div>
      <div :class="$style.row">
        <LocalAccountsInsights
          :item="item"
          :systemInfo="systemInfo.data ? systemInfo.data[0] : {}"
        />
      </div>
      <div :class="$style.row">
        <HardwareInsights
          :item="item"
          :systemInfo="systemInfo.data ? systemInfo.data[0] : {}"
        />
      </div>
      <div :class="$style.row">
        <DeviceInfo :item="item" />
        <NetworkInsights :item="item" />
      </div>
      <div :class="$style.row">
        <InsightsDetails :item="item" />
      </div>
    </div>
  </CollapsableSection>
</template>

<script>
import * as Constants from 'client/util/Constants';
import { mapGetters } from 'vuex';
import CollapsableSection from 'components/ContentSection/CollapsableSection.vue';
import IconCheckPremium from 'public/img/icons/icon-check-premium.svg?inline';
import PremiumFeatureFlag from 'components/Badges/PremiumFeatureFlag.vue';
import SystemInsightsApi from 'client/api/v2/SystemInsightsApi';

import DeviceInfo from './components/DeviceInfo.vue';
import HardwareInsights from './components/HardwareInsights.vue';
import InsightsDetails from './components/InsightsDetails.vue';
import InsightsSummary from './components/InsightsSummary.vue';
import LocalAccountsInsights from './components/LocalAccountsInsights.vue';
import NetworkInsights from './components/NetworkInsights.vue';

const { ItemTypeConsts, StoreModelMap } = Constants;
const storeModel = StoreModelMap[ItemTypeConsts.system];

export default {
  name: 'SystemInsights',

  components: {
    LocalAccountsInsights,
    CollapsableSection,
    DeviceInfo,
    HardwareInsights,
    InsightsDetails,
    InsightsSummary,
    NetworkInsights,
    PremiumFeatureFlag,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data: () => ({
    IconCheckPremium,
    systemInfo: {},
    storageInfo: {},
  }),

  computed: {
    ...mapGetters(storeModel, {
      isWindows: 'isWindows',
    }),
  },

  created() {
    /**
     * These API calls are being used in multiple child components, so it is being executed here and
     * the data is being passed down as props
     */
    SystemInsightsApi.getSystemInsight(this.item.id, 'system_info')
      .then((resp) => {
        if (resp.data) {
          this.systemInfo = resp;
        }
      });

    const endpoint = this.isWindows ? 'logical_drives' : 'mounts';
    SystemInsightsApi.getSystemInsight(this.item.id, endpoint, { params: { limit: 100 } })
      .then((resp) => {
        if (resp.data) {
          this.storageInfo = resp;
        }
      });
  },
};
</script>

<style module>
@value (max-width-x-large) from '~css/breakpoints.css';

.collapsableSection {
  overflow: visible !important;
}

.content { margin-bottom: var(--jc-spacer-negative-large); }

.icon { display: flex; }

.row {
  padding: var(--jc-spacer-small) var(--jc-spacer-small) 0 var(--jc-spacer-small);
}

.row > *:nth-child(n+2) { margin-top: var(--jc-spacer); }

@media (min-width: max-width-x-large) {
  .row { display: flex; }
  .row > * { flex: 1; }

  .row > *:nth-child(n+2) {
    margin-left: var(--jc-spacer-small);
    margin-top: 0;
  }
}

.firstRow {
  padding-bottom: var(--jc-spacer);
  padding-top: var(--jc-spacer-x-small);
}

</style>
